var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "usage-details",
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.searchButtonClicked()
        }
      }
    },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "rows", staticStyle: { margin: "3rem auto" } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.search,
                  expression: "search"
                }
              ],
              attrs: {
                name: "instance",
                type: "text",
                id: "instance",
                placeholder: _vm.$t("support.dashboard.instancename")
              },
              domProps: { value: _vm.search },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.search = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-success",
                on: {
                  click: function($event) {
                    return _vm.searchButtonClicked()
                  }
                }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("support.dashboard.searchButton")) +
                    "\n            "
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            _vm._s(_vm.$t("support.usageDetails.header")) +
              " " +
              _vm._s(_vm.instance)
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ct-row" }, [
          _c("div", { staticClass: "usage-infos" }, [
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("support.usageDetails.usageLicenseData")))
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "list-group" }, [
              _c(
                "li",
                {
                  staticClass: "list-group-item",
                  class: {
                    "usage-none": _vm.usage.persons === 1,
                    "usage-nonfree": _vm.usage.persons > 50
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("support.usageDetails.persons")) + ":"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.usage.persons))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "list-group-item",
                  class: {
                    "usage-none": _vm.usage.services === 8,
                    "usage-nonfree": _vm.usage.services > 10
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("support.usageDetails.services")) + ":"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.usage.services))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "list-group-item",
                  class: {
                    "usage-none": _vm.usage.resources === 3,
                    "usage-nonfree": _vm.usage.resources > 5
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("support.usageDetails.resources")) + ":"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.usage.resources))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "list-group-item",
                  class: {
                    "usage-none": _vm.usage.calendars === 3,
                    "usage-nonfree": _vm.usage.calendars > 5
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("support.usageDetails.calendars")) + ":"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.usage.calendars))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "list-group-item",
                  class: {
                    "usage-none": _vm.usage.stations === 1,
                    "usage-nonfree": _vm.usage.stations > 1
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("support.usageDetails.stations")) + ":"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.usage.stations))
                  ])
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ct-row" }, [
          _c("div", { staticClass: "usage-infos" }, [
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("support.usageDetails.usageDataLast30Days")))
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "list-group" }, [
              _c(
                "li",
                {
                  staticClass: "list-group-item",
                  class: {
                    "usage-none": _vm.usage.personsActive30Days === 0,
                    "usage-okay": _vm.usage.personsActive30Days > 0
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("support.usageDetails.personsActive30Days")
                        ) + ":"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.usage.personsActive30Days))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "list-group-item",
                  class: {
                    "usage-none": _vm.usage.persons30 === 0,
                    "usage-okay": _vm.usage.persons30 > 0
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("support.usageDetails.persons30")) + ":"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.usage.persons30))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "list-group-item",
                  class: {
                    "usage-none": _vm.usage.groups30 === 0,
                    "usage-okay": _vm.usage.groups30 > 0
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("support.usageDetails.groups30")) + ":"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.usage.groups30))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "list-group-item",
                  class: {
                    "usage-none": _vm.usage.csEntries30 === 0,
                    "usage-okay": _vm.usage.csEntries30 > 0
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("support.usageDetails.csEntries30")) + ":"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.usage.csEntries30))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "list-group-item",
                  class: {
                    "usage-none": _vm.usage.crEntries30 === 0,
                    "usage-okay": _vm.usage.crEntries30 > 0
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("support.usageDetails.crEntries30")) + ":"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.usage.crEntries30))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "list-group-item",
                  class: {
                    "usage-none": _vm.usage.calEntries30 === 0,
                    "usage-okay": _vm.usage.calEntries30 > 0
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("support.usageDetails.calEntries30")) +
                          ":"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.usage.calEntries30))
                  ])
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ct-row" }, [
          _c("div", { staticClass: "usage-infos" }, [
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("support.usageDetails.licenseOverUnder")))
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "list-group" }, [
              _c(
                "li",
                {
                  staticClass: "list-group-item",
                  class: {
                    "usage-okay": _vm.usage.currentPrice > _vm.usage.bestPrice
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("support.usageDetails.overLicensed")) +
                          ":"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.usage.currentPrice - _vm.usage.bestPrice > 0
                          ? _vm.usage.currentPrice - _vm.usage.bestPrice
                          : 0) /
                          100 +
                          "€"
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "list-group-item",
                  class: {
                    "usage-none": _vm.usage.bestPrice > _vm.usage.currentPrice
                  }
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("support.usageDetails.underLicensed")) +
                          ":"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "content" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.usage.bestPrice - _vm.usage.currentPrice > 0
                          ? _vm.usage.bestPrice - _vm.usage.currentPrice
                          : 0) /
                          100 +
                          "€"
                      )
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a4e0d53", { render: render, staticRenderFns: staticRenderFns })
  }
}